import React, { useEffect } from "react";
import "../App.css"; // Import the CSS file for styles
import 'animate.css';
import WOW from 'wowjs';

function ContactForm() {
  useEffect(() => {
    // Initialize WOW.js for scroll animations
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted!");
  };

  return (
    <form 
      className="contact-form wow animate__animated animate__fadeInLeft" 
      data-wow-duration="1.5s" 
      onSubmit={handleSubmit}
    >
      <h2>Contact Us</h2>
      <div className="form-group">
        <label htmlFor="name">Name</label>
        <input type="text" id="name" placeholder="Your Name" required />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input type="email" id="email" placeholder="Your Email" required />
      </div>
      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea id="message" placeholder="Your Message" rows="5" required></textarea>
      </div>
      <button type="submit" className="submit-btn">
        Send Message
      </button>
    </form>
  );
}

export default ContactForm;
